import { favouriteConstants } from "../../_constants";

const initialState = {};

// update mentor reducer
export const create_shortlisting_candidate_by_hm_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case favouriteConstants.CREATE_SHORTLIST_CANDIDATE_BY_HM_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case favouriteConstants.CREATE_SHORTLIST_CANDIDATE_BY_HM_ACTION_SUCCESS:
      return {
        type: "alert-success",
        shortlistedCandidateData: action.payload,
      };
    case favouriteConstants.CREATE_SHORTLIST_CANDIDATE_BY_HM_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

// mentor profile
export const update_shortlisted_candidate_by_hm_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case favouriteConstants.UPDATE_SHORTLISTED_CANDIDATE_BY_HM_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case favouriteConstants.UPDATE_SHORTLISTED_CANDIDATE_BY_HM_ACTION_SUCCESS:
      return {
        type: "alert-success",
        updatedShortlistedCandidateData: action.payload,
      };
    case favouriteConstants.UPDATE_SHORTLISTED_CANDIDATE_BY_HM_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

export const hm_delete_shortlisted_candidate_by_id_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case favouriteConstants.DELETE_SHORTLISTED_CANDIDATE_BY_HM_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case favouriteConstants.DELETE_SHORTLISTED_CANDIDATE_BY_HM_ACTION_SUCCESS:
      return {
        type: "alert-success",
        deletedShortlistedCandidateData: action.payload,
      };
    case favouriteConstants.DELETE_SHORTLISTED_CANDIDATE_BY_HM_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

// mentor education by id
export const get_shortlisted_candidates_by_hm_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case favouriteConstants.GET_SHORTLISTED_CANDIDATES_DATA_BY_HM_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case favouriteConstants.GET_SHORTLISTED_CANDIDATES_DATA_BY_HM_ACTION_SUCCESS:
      return {
        type: "alert-success",
        allShortlistedCandidateData: action.payload,
      };
    case favouriteConstants.GET_SHORTLISTED_CANDIDATES_DATA_BY_HM_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

